<template>
  <div class="container-fluid p-0" style="height: 100vh">
    <div class="row">
      <div class="col-12 col-md-9">
        <div class="container-fluid p-0">
          <div class="row">
            <nav class="nav-menu2-vpos">
              <div class="d-flex justify-content-between">
                <div class="d-flex justify-content-center w-50">
                  <span
                    class="w-25 title m-auto"
                    style="font-family: system-ui"
                  >
                    CỬA HÀNG</span
                  >

                  <input
                    class="m-auto input-search"
                    type="search"
                    name=""
                    placeholder="Tìm kiếm cửa hàng..."
                  />
                  <button class="btn-search">Tìm</button>
                </div>
                <div class="d-flex w-25">
                  <div class="m-auto">
                    <input type="checkbox" /> <span class="p-2"> Chung</span>
                  </div>
                  <div class="m-auto">
                    <input type="checkbox"  v-model="myStore"/> <span class="p-2"> Riêng</span>
                  </div>
                </div>
              </div>
            </nav>
            <HomeSlideVposVue v-if="!myStore"></HomeSlideVposVue>
            <ul class="mt-3" v-if="myStore">
              <li v-for="store in listCuaHang" :key="store.id" class="p-2">
                <div class="w-100 p-3" style="    height: 45px;  background-color: rgb(239 239 239);border-radius: 10px; border-bottom: 2px rgb(185 185 185) solid; text-align: start; cursor: pointer;">
              <span style="font-weight: 600; margin-left: 20px;">{{ store.storeName }}  </span> | <span> {{ store.storeAdd }}</span> </div>
              </li>
            </ul>
            <CreateStore class="d-none"></CreateStore>

          </div>
        </div>
      </div>
      <div
        class="col-12 col-md-3 p-0"
        style="background-color: #f8f8f8; height: 100vh"
      >
        <VposLoginVue v-if="Login"></VposLoginVue>
        <MainMenuVposVue v-if="menuThongTin"></MainMenuVposVue>
        <VposRegister v-if="register"></VposRegister>
      </div>
    </div>
  </div>
</template>
<script>
import VposLoginVue from "../Accounts/VposLogin.vue";
import MainMenuVposVue from "./MainMenuVpos.vue";
import VposRegister from "../Accounts/VposRegister.vue";
import HomeSlideVposVue from "./HomeSlideVpos.vue";
import CreateStore from "../DashHome/CreateStore.vue";

export default {
  components: {
    MainMenuVposVue,
    VposLoginVue,
    VposRegister,
    HomeSlideVposVue,
    CreateStore
  },
  data() {
    return {
      Login: false,
      menuThongTin: false,
      register: false,
      user: "",
      listCuaHang: [],
      bannerQuangCao: true,
      myStore : false,
    };
  },
  mounted() {
    this.checkLogin();
    this.handleDataReceived();
    // this.$parent.$on('dataCuaHang', this.handleDataReceived);
  },
  // beforeDestroy() {
  //   this.$parent.$off('dataCuaHang', this.handleDataReceived);
  // },
  methods: {
    checkLogin() {
      this.user = localStorage.getItem("user");
      console.log(this.user);
      if (this.user == "" || this.user == null) {
        this.Login = true;
        this.menuThongTin = false;
      } else {
        this.menuThongTin = true;
        this.Login = false;
      }
    },
    handleDataReceived() {
      var data = localStorage.getItem("dataCuaHang");
      console.log("data ", data);
      this.listCuaHang = JSON.parse(data);
    },
  },
};
</script>